<div>
  <div class="disclaimers-header align-center p--md">
    {{ providerName }} Disclaimer
  </div>
  <div mat-dialog-content class="mt--sm">
    <form [formGroup]="disclaimersForm" (ngSubmit)="save()">
      <div formArrayName="disclaimers">
        <div
          *ngFor="let disclaimer of disclaimers.controls; let i = index"
          [formGroupName]="i"
          class="disclaimer-card mb--md"
        >
          <div class="row">
            <div class="column--9">
              <mat-slide-toggle color="primary" formControlName="visible" (change)="onVisibleToggled(i)">
                {{ disclaimer.get('visible')?.value ? 'Visible' : 'Hidden' }}
              </mat-slide-toggle>
            </div>
            <div class="column--3 align-right">
              <button mat-icon-button color="warn" type="button" aria-label="Delete disclaimer" (click)="removeDisclaimer(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="column--12">
              <mat-form-field class="full-width">
                <mat-label>Title</mat-label>
                <input matInput formControlName="title" />
                <mat-error *ngIf="disclaimer.get('title')?.errors?.['required']">Title is required</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="column--12">
              <mat-form-field class="full-width">
                <mat-label>Content</mat-label>
                <textarea matInput formControlName="content" rows="4"></textarea>
                <mat-error *ngIf="disclaimer.get('content')?.errors?.['required']">Content is required</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="column--12">
              <mat-checkbox color="primary" formControlName="requireCheckbox">
                <span class="no-bold">Require checkbox</span>
              </mat-checkbox>
            </div>
          </div>
          <div class="row" formGroupName="destinations">
            <div class="column--12">
              <p class="mb--xs">Display for shipments to</p>
              <div *ngFor="let destination of destinationOptions" class="destination-option">
                <mat-checkbox color="primary" [formControlName]="destination.key">
                  <span class="no-bold">{{ destination.label }}</span>
                </mat-checkbox>
              </div>
              <p
                class="destination-hint text--sm"
                [class.destination-hint--error]="
                  disclaimer.get('destinations')?.touched && disclaimer.get('destinations')?.errors?.['atLeastOneRequired']
                "
              >
                Select at least one destination.
              </p>
            </div>
          </div>
        </div>
      </div>

      <button class="add-disclaimer full-width mb--md" type="button" (click)="addDisclaimer()">
        + Add disclaimer
      </button>

      <div class="row" mat-dialog-actions>
        <div class="column--3"><button mat-flat-button mat-dialog-close color="accent" type="button">Cancel</button></div>
        <div class="column--9 align-right">
          <button mat-flat-button color="primary" type="submit" cdkFocusInitial>Save</button>
        </div>
      </div>
    </form>
  </div>
</div>
